import { LOGIN } from "../constants/actionTypes";
import * as api from "../api/index";

export const login = (userData, navigate) => async (dispatch) => {
  try {
    const { data } = await api.logIn(userData);

    dispatch({ type: LOGIN, data, error: null });
    const user = data.value[0].role;

    if (!user) {
      navigate("/");
      return;
    }

    // send_score users are limited to the Send Score Form page only.
    if (user === "send_score") {
      navigate("/send-score");
      return;
    }

    // super-admin lands directly on the manager-approval queue.
    if (user === "super-admin") {
      navigate("/main/send_score_submissions");
      return;
    }

    if (user) {
      navigate("/main");
      return;
    }
  } catch (error) {
    dispatch({ type: LOGIN, data: null, error });
  }
};
